<script>
	import { postSettings } from "./stores.js";

	import StepSelect from "./components/StepSelect.svelte";
	import SegControl from "./components/SegControl.svelte";

	const layouts = [
		{
			id: 1,
			slug: "one-field",
			name: "Body Only",
			get img() {
				return "img/" + this.slug + ".svg";
			}
		},
		{
			id: 2,
			slug: "two-field",
			name: "Header + Body",
			get img() {
				return "img/" + this.slug + ".svg";
			}
		},
		{
			id: 3,
			slug: "two-field-alt",
			name: "Body + Footer",
			get img() {
				return "img/" + this.slug + ".svg";
			}
		},
		{
			id: 4,
			slug: "three-field",
			name: "Triple Field",
			get img() {
				return "img/" + this.slug + ".svg";
			}
		}
	];

	const alignments = [
		{
			id: 1,
			val: "top",
			label: "Top",
			img: "img/box-align-top.svg"
		},
		{
			id: 2,
			val: "middle",
			label: "Middle",
			img: "img/box-align-middle.svg"
		},
		{
			id: 3,
			val: "bottom",
			label: "Bottom",
			img: "img/box-align-bottom.svg"
		},
		{
			id: 4,
			val: "distribute",
			label: "Distribute",
			img: "img/box-align-distribute.svg"
		}
	];

</script>

<div class="panel--title">
	<h2>Post Layout</h2>
</div>

<div class="panel--body">
	<h4>Post Type</h4>

	<StepSelect items={layouts} bind:val={$postSettings.fields}/>

	<h4>Post Alignment</h4>

	<SegControl items={alignments} bind:group={$postSettings.valign} name='valign' icon={true} />

</div>

<style lang="scss">
	
</style>

